import { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { useWindowSize } from './../../hooks/useWindowResize';
import {
  Container,
  SignatureContainer,
  SignatureLabelsContainer,
  SignatureLabel,
  SignatureClear,
} from './styles';

interface SignaturePadProps {
  width?: number | null;
  height?: number | null;
}

const messageParent = (data: string | null) => {
  if (window && window.parent) {
    window.parent.postMessage(
      {
        message: 'Signature Complete',
        complete: 'true',
        data: data,
      },
      '*'
    );
  }
};

export const SignaturePad: React.FC<SignaturePadProps> = () => {
  const { width } = useWindowSize();
  const signaturePadHeight = '100px';
  const signaturePadWidth = width ? width - 20 : 0;

  const signCanvas = useRef() as React.MutableRefObject<any>;

  const onSignatureEnd = () => {
    signCanvas.current.getTrimmedCanvas().toDataURL('image/png');
    messageParent(signCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
  };

  const clearSignature = () => {
    signCanvas.current.clear();
    messageParent('');
  };

  return (
    <Container>
      <SignatureContainer>
        <SignatureLabelsContainer>
          <SignatureLabel>Sign your waiver</SignatureLabel>
          <SignatureClear onClick={clearSignature}>Clear</SignatureClear>
        </SignatureLabelsContainer>
        <SignatureCanvas
          ref={signCanvas}
          penColor='black'
          canvasProps={{
            width: `${signaturePadWidth}px`,
            height: `${signaturePadHeight}px`,
          }}
          onEnd={onSignatureEnd}
        />
      </SignatureContainer>
    </Container>
  );
};

export default SignaturePad;
